import React, { useState } from 'react';
import {Flex, SVGButton, Arrow} from '/app/src/component'
import _ from 'lodash'
import OutsideClickHandler from 'react-outside-click-handler';

const ItemStyle={
    fontSize: '14px',
    height: '28px',
    marginLeft: '5px',
    marginBottom: '5px',
    iconPos: 'right',
    color: 'black',
    backgroundColor: 'mediumgrey',
    borderActive: 'JibberBlue_M',
    backgroundActive: 'LightBlue1',
    srcActive: '/images/Options_S.svg',
}

const ModalStyle = {
    position: 'absolute',
    borderRadius: '20px',
    top: '100%',
    padding: '8px 11px',
    boxShadow: '0 5px 10px 0 rgba(0, 0, 0, 0.16)',
    backgroundColor: 'white',
    wrap: true,
    grow: 1,
    zIndex:100,
    left: '5%',
    width: '90%',
    maxWidth: '350px'

}
const ModalHeaderButtonStyle = {
    src: '/images/Notification.svg' ,
}
const ModalButtonStyle={
    fontSize: '14px',
    height: '28px',
    marginRight: '4px',
    marginBottom: '5px',
}
const Modal = ({item, onUpdateItem, parentId, close}) => {
    const active = item.notification
    return (
        <OutsideClickHandler onOutsideClick={close}>
        <Flex {...ModalStyle}>
            <SVGButton text={item.label} color={active?'blue':'black'} {...ModalHeaderButtonStyle} {...ModalButtonStyle}
                onClick={()=>{onUpdateItem(item.id)}}
                >
                <Arrow direction='right' color={active?'blue':'black'} height='20px' minWidth='0px!important'/>
            </SVGButton>
            {_.map(item.children, (c)=>{
                if(!c.visible) return null;
                var act = c.notification
                return <SVGButton
                    key={c.id}
                    text={c.label} {...ModalButtonStyle}
                    active={act}
                    {...ItemStyle}
                    onClick={()=>{onUpdateItem(parentId, c.id)}}
                    />
            })}
        </Flex>
        </OutsideClickHandler>
    )
}


export default function ({item, onUpdateItem})  {
    const hasVisibleChild = _.some(item.children, c=>{return c.visible})

    const [modal, setModal] = useState(false)

    const _onClick = ()=>{
        if(hasVisibleChild){
            setModal(!modal)
        }else{
            onUpdateItem(item.id)
        }
    }

    const ItemProps = {
        dataName: 'ExchangeNotificationItem',
        text: item.label,
        onClick: _onClick
    }


    return(
        <Flex shrink={0}>
            <SVGButton {...ItemProps} {...ItemStyle} active={item.notification} color={modal&&'blue'} src={hasVisibleChild&& '/images/Options_S.svg'}/>
            {modal &&<Modal item={item} onUpdateItem={onUpdateItem} parentId={item.id} close={()=>{setModal(false)}}/>}
        </Flex>
    )
}



// WEBPACK FOOTER //
// ./src/layout/Dashboard/LeftPanel/ExchangeNotification/_item.js